import _isEmpty from 'lodash/isEmpty';
import Fuse from 'fuse.js';

const MAX_SEARCH_SIZE = 10;

// To filter out search object; options: parents, topicNode
const topicNodeFilter = (options = {}) => (
  Object.assign({}, options.topicNode, { parents: options.parents && options.parents.slice() })
);

// To generate Search Pool; options: subTopicsArrays, parentsPath, finalSearchPool
const dfsHelper = (options) => {
  const topicNode = options.node;
  if (_isEmpty(topicNode)) {
    return null;
  }

  // Find the leaf node and add to Search pool
  if (_isEmpty(topicNode.sub_topics) && topicNode.leaf_node && Array.isArray(options.parents)) {
    options.searchPool.push(topicNodeFilter({ topicNode, parents: options.parents }));
  }

  if (Array.isArray(topicNode.sub_topics)) {
    topicNode.sub_topics.forEach((subTopic) => {
      options.parents.push(subTopic.topic_name); // Push current topic name input parent array
      dfsHelper({ node: subTopic, parents: options.parents, searchPool: options.searchPool });
      options.parents.pop(); // Remove the last add topic name for recursive DFS search
    });
  }

  return null;
};

const topicSearchPool = (topicTreeRoot) => {
  const searchPool = [];
  dfsHelper({ node: topicTreeRoot, parents: [], searchPool });
  return searchPool;
};

const getFuseOptions = () => ({
  shouldSort: true,
  threshold: 0.4,
  location: 0,
  distance: 100,
  maxPatternLength: 10,
  minMatchCharLength: 1,
  keys: [
    'ref_id',
    'topic_name',
    'parents',
  ],
});

// getSearchResult({ searchPool, query: 'money' });
// Get Search Result by using Fuse.js; options: searchPool, query. size
const getSearchResult = (options = {}) => {
  const params = getFuseOptions();
  const query = options.query;
  const searchPool = options.searchPool;
  const size = options.size || MAX_SEARCH_SIZE;

  if (query && Array.isArray(searchPool) && searchPool.length > 0) {
    const fuse = new Fuse(searchPool, params);
    const result = fuse.search(query).slice(0, size);
    return result;
  }

  return null;
};

const fuseOptionForTopicId = () => ({
  shouldSort: true,
  threshold: 0.0,
  location: 0,
  distance: 100,
  maxPatternLength: 10,
  minMatchCharLength: 1,
  keys: [
    'ref_id',
  ],
});

const getTopicId = (options = {}) => {
  const params = fuseOptionForTopicId();
  const query = options.query; // Email Ref Id
  const searchPool = options.searchPool;

  if (query && Array.isArray(searchPool) && searchPool.length > 0) {
    const fuse = new Fuse(searchPool, params);
    const result = fuse.search(query).slice(0, 1);
    if (Array.isArray(result) && result.length) {
      return result[0];
    }
  }

  return null;
};

module.exports = {
  topicSearchPool,
  getSearchResult,
  getTopicId,
};
